/**
 * RequireAuth — гейт принудительного входа (D11). Нет per-user токена → экран входа.
 * Токен появляется после Google-OIDC (captureTokenFromUrl в main.tsx до рендера); при протухании
 * self-heal в client.ts чистит его и перезагружает → снова этот экран.
 */
import { FC, ReactNode } from 'react';

import { getUserToken } from '../shared/auth/userToken';
import { LoginScreen } from './LoginScreen';

export const RequireAuth: FC<{ children: ReactNode }> = ({ children }) => {
  if (!getUserToken()) return <LoginScreen />;
  return <>{children}</>;
};
